import { isMobileApp } from '@airtel-lego/native-app-bridge';
import { getFromSessionStorage, isSessionSupported } from './commonUtils';
import { desEncryptMessage, encryptSecretKey } from '@airtel/air-utils';
import { BASE_HREF } from './routes/Routing';
import { fireDynamicEvents } from '../utils';

export const handleThanksPageOnLoad = (onUserAction: any, getState: any) => {
   const { storeValues } = getState();

   const actions = [];

   let search = window.location.search;
   let params = new URLSearchParams(search);
   let referenceID = params.get('referenceID');
   let mobileNumber = params.get('mobileNumber');

   let journey = 'addOn';
   if (isSessionSupported()) {
      const journeyType = getFromSessionStorage('journeyType');
      journey = journeyType?.journey;
   }
   const isAddonJourney = journey === 'addOn';
   let version = storeValues?.versionContext?.version ?? 'v9';
   if (isAddonJourney) {
      version = 'v1';
   }

   if (referenceID) {
      // no payment case
      const successPayload = {
         type: 'nativeEventEmitter',

         payload: {
            eventName: 'familyThankyouPageStatusCard',

            eventData: {
               id: 'familyThankyouPageStatusCard',

               title: {
                  text: 'Request recieved',
                  tagName: "h1",
                  accessibilityLiveRegion: "assertive",
               },

               subtitle: {
                  text: isAddonJourney
                     ? 'Your add-on SIM will be activated in next 1 hr.'
                     : 'Your number will be converted to postpaid in next 1 hr.',
               },

               type: 'svg',

               svg: {
                  iconName: 'TickIcon',

                  svgBackgroundProps: {
                     type: 'LUSH',
                  },
               },

               withCard: true,

               showCollapsible: true,

               collapsibleData: [
                  {
                     title: 'request ID',

                     value: referenceID,
                  },

                  {
                     title: 'contact details',

                     value: mobileNumber,
                  },
               ],

               collapsibleCtaData: {
                  collapseCtaTitle: 'view more',

                  expandedCtaTitle: 'view less',
               },

               showTitleSection: true,

               breakpointProps: {
                  xl: {
                     style: {
                        width: 600,

                        alignSelf: 'center',
                     },
                  },

                  lg: {
                     style: {
                        width: 600,

                        alignSelf: 'center',
                     },
                  },

                  md: {
                     style: {
                        width: 600,

                        alignSelf: 'center',
                     },
                  },
               },

               styles: {},

               titleSectionProps: {
                  hideTopPadding: false,

                  hideBottomPadding: false,

                  backgroundColor: '#ECEDFF',

                  childCardProps: {
                     style: {
                        marginTop: 12,
                     },

                     padding: 'SPACING_4',

                     noHorizontalPadding: true,
                  },
               },
            },
         },
      };

      actions.push(successPayload);

      let apiUrlPostpaidConnection =
         'guardian/api/buy/postpaid/prepaid-to-postpaid/postpaidConnections/' + version;
      if (isAddonJourney) {
         apiUrlPostpaidConnection =
            'guardian/api/buy/postpaid/prepaid-to-postpaid/postpaidConnections/addOn/v1';
      }

      const experienceApiPayload = {
         type: 'apiCall',
         payload: {
            requestType: 'GET',
            apiUrl: apiUrlPostpaidConnection,
            authTokenGroup: 'FAMILY_PARENT',
            transactUserGroup: isAddonJourney ? 'FAMILY_CHILD' : null,
            header: {
               'X-Consumer-Name': '',
               'X-Consumer-Journey': '',
               channel: isAddonJourney ? storeValues?.manageDetails?.channel : null
            },
            queryParams: {
               orderId: referenceID,
               siNumber: mobileNumber,
               journey,
            },
         },
      };
      const showLoaderAction = {
         type: 'nativeEventEmitter',
         payload: {
            eventName: 'PostpaidFamilyConnectionSection_ScrollLinkListWidget',
            eventData: {
               showSkeletonLoader: true,
               skeletonLoaderProps: {
                  fullWidth: true,
                  type: 'list-item',
                  numberOfViews: 1,
                  style: {
                     marginRight: 20,
                     marginLeft: 20,
                     marginTop: 20,
                  },
               },
            },
         },
      };
      actions.push(showLoaderAction);
      actions.push(experienceApiPayload);
   } else {
      //payment case call order api

      let apiUrlSentOtp = 'guardian/api/buy/postpaid/prepaid-to-postpaid/sendOtp/';

      if (isAddonJourney) {
         apiUrlSentOtp = 'guardian/api/buy/postpaid/prepaid-to-postpaid/sendOtp/addOn/';
      }
      const orderPayload = {
         type: 'apiCall',
         header: {},
         payload: {
            requestType: 'POST',
            apiUrl: apiUrlSentOtp + version,
            body: {},
            queryParams: {
               journey,
            },
         },
      };

      actions.push(orderPayload);
   }

   return onUserAction({
      actions,
   });
};

const isUserLoggedIn = (siNumber: string) => {
   if (localStorage.getItem(LOGIN_CONSTANTS.loggedInUser)) {
      const existingSiNumber = localStorage.getItem(LOGIN_CONSTANTS.loggedInUser);
      if (decodeData(existingSiNumber ?? '') === siNumber) {
         //session already exists
         return true;
      }
   }
   return false;
};

export const redirectToHomeApi = (data: any, onUserAction: any, getState: any) => {
   const { storeValues } = getState();

   // if cartid, cartItemId, msisdn are null then navigate to getPlanDetail Page
   const cartId = storeValues?.cartContext?.cartId;
   const cartItemId = storeValues?.cartContext?.cartItemId;
   // const parentNumber = storeValues?.rtn?.parentRtn
   const msisdn = storeValues?.appData?.msisdn; // might be child's number as well

   const dependentOrderId = storeValues?.orderContext?.orderItemId; // child dependent order item id
   const channel = storeValues?.manageDetails?.channel;

   let search = window.location.search;
   let params = new URLSearchParams(search);
   let journey = 'addOn';
   if (isSessionSupported()) {
      const journeyType = getFromSessionStorage('journeyType');
      journey = journeyType?.journey;
   }
   let siNumber = params.get('siNumber');

   if (journey == 'addOn') {
      if (dependentOrderId == null && channel != "THANKS_APP") {
         return onUserAction({
            actions: [
               {
                  type: 'navigation',
                  payload: {
                     id: 'redirection',
                     screenName: '/add-connection',
                     shouldAddSearchParams: true,
                     params: {
                        screenQueryParams: {
                           siNumber: siNumber,
                           journey: 'addOn',
                        },
                     },
                     type: 'replace',
                  },
               },
            ],
         });
      }
   } else {
      if (cartId == null || cartItemId == null || msisdn == null) {
         //this case will happen in parent action
         const url = `https://${window.location.hostname}${BASE_HREF}/`
         return onUserAction({
            actions: [
               {
                  type: 'navigation',
                  payload: { externalUrl: url, shouldAddSearchParams: true },
               },
            ],
         });
      }
   }
};

export const callLoginSendOtpApi = (data: any, onUserAction: any, getState: any) => {
   const { storeValues } = getState();
   const isCoipUser = !!storeValues?.userData?.isCoipUser;
   const msisdn = storeValues?.appData?.msisdn;
   let version = storeValues?.versionContext?.version ?? 'v9';

   if(isCoipUser) {
    version = 'v20';
   }

   let search = window?.location?.search;
   let params = new URLSearchParams(search);

   let journey = 'addOn';
   if (isSessionSupported()) {
      const journeyType = getFromSessionStorage('journeyType');
      journey = journeyType?.journey;
   }
   const isAddonJourney = journey === 'addOn';
   if (isAddonJourney) {
      version = 'v1';
   }

   let isOtpModalOpened = data?.[0]?.type == 'resend' ? true : false;
   let payloadReq = {};
   const publicKey = localStorage.getItem('key');

   if (publicKey) {
      const payload: any = {
         msisdn: msisdn,
         otpDigitCount: 4,
         groupId: journey == 'P2P' ? 'BUY_P2P_WEB' : 'BUY_ADDON_WEB',
         os: 'WEB',
      };

      //encrypt the request using DES Algo
      payloadReq = encryptMessage(payload, publicKey);

      let apiUrlSentOtp = 'guardian/api/buy/postpaid/prepaid-to-postpaid/sendOtp/';

      if (isAddonJourney) {
         apiUrlSentOtp = 'guardian/api/buy/postpaid/prepaid-to-postpaid/sendOtp/addOn/';
      }

      // to fire dynamic event for chatbot on thanks app 
      fireDynamicEvents(msisdn, 'PAGE_LOAD', 'common_add_details_page')

      return onUserAction({
         actions: [
            {
               payload: {
                  eventData: {
                     changeNumberCta: 'change',
                     infoTextBottom: '',
                     startCounter: true,
                     state: 'none',
                     rtn: msisdn,
                  },
                  eventName: 'artistOtpModal',
               },
               type: 'nativeEventEmitter',
            },
            {
               payload: {
                  modalData: [],
                  modalSection: 'OtpModalSection',
               },
               type: 'openModal',
            },
            {
               type: 'apiCall',
               header: {},
               payload: {
                  requestType: 'POST',
                  apiUrl: apiUrlSentOtp + version,
                  body: {
                     key: payloadReq,
                     msisdn,
                     isOtpModalOpened,
                     journey,
                     isCommon: true,
                  },
                  queryParams: {
                     journey,
                     isCommon: true,
                  },
               },
            },
         ],
      });
   }

   return payloadReq;
};

export const prepareLoginValidateOtpApi = (
   data: any,
   onUserAction: any,
   getState: any
) => {
   const { storeValues } = getState();
   const msisdn = storeValues?.appData?.msisdn;
   const otp = storeValues?.childOtp?.otp;
   let version = storeValues?.versionContext?.version ?? 'v9';

   const isCoipUser = !!storeValues?.userData?.isCoipUser;
   if (isCoipUser) version = 'v20';

   let search = window.location.search;
   let params = new URLSearchParams(search);
   let journey = 'addOn';
   if (isSessionSupported()) {
      const journeyType = getFromSessionStorage('journeyType');
      journey = journeyType?.journey;
   }
   const isAddonJourney = journey === 'addOn';
   if (isAddonJourney) {
      version = 'v1';
   }

   //key

   const publicKey = localStorage.getItem('key');
   if (publicKey) {
      const payload: any = {
         msisdn: msisdn,
         otpDigitCount: 4,
         dynamicTokenRequired: true,
         otp: otp,
         groupId: journey == 'P2P' ? 'BUY_P2P_WEB' : 'BUY_ADDON_WEB',
         os: 'WEB',
      };
      // encrypt the request using DES Algo
      const payloadReq = encryptMessage(payload, publicKey);

      let apiUrlValidateLogin =
         'guardian/api/buy/postpaid/prepaid-to-postpaid/validateLogin/';
   

      if (isAddonJourney) {
         apiUrlValidateLogin =
            'guardian/api/buy/postpaid/prepaid-to-postpaid/validateLogin/addOn/';
      }

      // to fire dynamic event for chatbot on thanks app 
      fireDynamicEvents(msisdn, 'OTP_VERIFIED', 'common_add_details_page')

      return onUserAction({
         actions: [
            {
               type: 'apiCall',
               header: {},
               payload: {
                  requestType: 'POST',
                  apiUrl: apiUrlValidateLogin + version,
                  body: {
                     key: payloadReq,
                     journey,
                     isCommon: true,
                  },
                  queryParams: {
                     journey,
                     isCommon: true,
                  },
               },
            },
         ],
      });
   }
};

export const LOGIN_CONSTANTS = {
   staticToken: 'static-token',
   dynamicToken: 'dynamic-token',
   uid: 'uid',
   loggedInUser: 'aa-auk',

   staticTokenAddOn: 'static-token-addon',
   dynamicTokenAddOn: 'dynamic-token-addon',
   uidAddOn: 'uid-addon',
   loggedInUserAddOn: 'aa-auk-addon',
   coipGroupId: 'COIP_EMAIL_FLOW'
};

/**
 * return true if localStorageSupported
 */
export const isLocalStorageSupported = () => {
   const testKey = 'test';
   try {
      const storage = window?.localStorage;
      storage.setItem(testKey, '1');
      storage.removeItem(testKey);
      return true;
   } catch (error) {
      return false;
   }
};

const getPOQBodyForBundling = () => {
   return [
      {
         product: {
            characteristic: [
               {
                  name: 'uniqueIdentifier',
                  value: {
                     textValue: `ACC${new Date().getTime()}`,
                  },
               },
               {
                  name: 'productType',
                  value: {
                     textValue: 'POSTPAID',
                  },
               },
            ],
            poqItem: [
               {
                  contactMedium: [],
                  product: {
                     characteristic: [
                        {
                           name: 'orderType',
                           value: {
                              textValue: 'PRE_TO_POST',
                           },
                        },
                        {
                           name: 'orderSubType',
                           value: {
                              textValue: 'P2P',
                           },
                        },
                        {
                           name: 'version',
                           value: {
                              textValue: 'v2',
                           },
                        },
                        {
                           name: 'rtn',
                           value: {
                              textValue: '{{storeValues:appData.msisdn}}',
                           },
                        },
                        {
                           name: 'uniqueIdentifier',
                           value: {
                              textValue: createUUID(),
                           },
                        },
                        {
                           name: 'connectionType',
                           value: {
                              textValue: 'PRIMARY',
                           },
                        },
                        {
                           name: 'hvCheckRequired',
                           value: {
                              booleanValue: true,
                           },
                        },
                        {
                           name: 'productType',
                           value: {
                              textValue: 'POSTPAID',
                           },
                        },
                     ],
                     productOffering: {},
                     productPrice: [],
                     realizingResource: [
                        {
                           name: 'siNumber',
                           value: {
                              textValue: '{{storeValues:appData.msisdn}}',
                           },
                        },
                     ],
                  },
               },
            ],
         },
      },
   ];
};

const getPOQBodyForHV = (msisdn: string, journey: string | null, isCoipUser: boolean, email: String) => {
   const baseObj = {
      productOfferingQualificationItem: [
         {
            product: {
               productCharacteristic: [
                  {
                     name: 'uniqueIdentifier',
                     value: {
                        textValue: `ACC${new Date().getTime()}`,
                     },
                  },
                  {
                     name: 'productType',
                     value: {
                        textValue: 'POSTPAID',
                     },
                  },
               ],
               productOfferingQualificationItem: [
                  {
                     contactMedium: [],
                     product: {
                        productCharacteristic: [
                           {
                              name: 'orderType',
                              value: {
                                 textValue: 'PRE_TO_POST',
                              },
                           },
                           {
                              name: 'orderSubType',
                              value: {
                                 textValue: 'P2P',
                              },
                           },
                           {
                              name: 'version',
                              value: {
                                 textValue: 'v2',
                              },
                           },
                           {
                              name: 'rtn',
                              value: {
                                 textValue: msisdn,
                              },
                           },
                           {
                              name: 'uniqueIdentifier',
                              value: {
                                 textValue: createUUID(),
                              },
                           },
                           {
                              name: 'connectionType',
                              value: {
                                 textValue: 'PRIMARY',
                              },
                           },
                           {
                              name: 'hvCheckRequired',
                              value: {
                                 booleanValue: true,
                              },
                           },
                           {
                              name: 'productType',
                              value: {
                                 textValue: 'POSTPAID',
                              },
                           },
                        ],
                        productOffering: {},
                        productPrice: [],
                        realizingResource: [
                           {
                              name: 'siNumber',
                              value: {
                                 textValue: msisdn,
                              },
                           },
                        ],
                     },
                  },
               ],
            },
         },
      ],
      milestone: 'HIGH_VALUE',
      journey: journey,
      channel: 'SHOP',
      operationName: 'FAMILY',
      applicationId: 'FAMILY',
      msisdn: msisdn,
   };

   if (isCoipUser) {
      //add coip flags
      const productOfferingList = baseObj?.productOfferingQualificationItem?.[0]?.product?.productOfferingQualificationItem?.[0]?.product?.productCharacteristic

      const contactMediumArray: any = baseObj?.productOfferingQualificationItem?.[0]?.product?.productOfferingQualificationItem?.[0]?.contactMedium;

      if (contactMediumArray) {
         contactMediumArray.push({
            mediumType: 'billingAddress',
            characteristic: {
               emailAddress: email,
            },
         });
      }

      if (productOfferingList) {
         productOfferingList.push({
            "name": "productSubSegment",
            "value": {
               "textValue": 'BUSINESS'
            }
         })
      }
   }


   return baseObj;
};

export const storeTokens = (data: any, onUserAction: any, getState: any) => {
   const { storeValues } = getState();

   const msisdn = storeValues?.appData?.msisdn;
   let version = storeValues?.versionContext?.version ?? 'v9';
   const firstEligibility = storeValues?.POQContext?.firstEligibility;
   const skipPOQ = ['AON_LESS_THAN_90', 'CIRCLE_JK'].includes(firstEligibility);

   //for coip case
   const isCoipUser = !!storeValues?.userData?.isCoipUser;
   const coipEmail = storeValues?.userData?.email;
   if (isCoipUser) version = 'v20';


   let authTokensData = data?.[0];
   const actions = [];
   let search = window.location.search;
   let params = new URLSearchParams(search);
   let journey = 'addOn';
   if (isSessionSupported()) {
      const journeyType = getFromSessionStorage('journeyType');
      journey = journeyType?.journey;
   }
   const isAddonJourney = journey === 'addOn';
   if (isAddonJourney) {
      version = 'v1';
   }

   let utmSource = params.get('utm_source');
   let referralCode = params.get('rC');
   let refRtn = params.get('refRtn');

   const isReferralJourney = utmSource?.toLowerCase()?.includes('referral') && !!referralCode && !!refRtn ;


   const isHV = !isAddonJourney && storeValues?.HVContext?.isHV == 'HIGH_VALUE';

   const reduxActionObj = {
      type: 'setDataInSessionStorage',
      target: 'session',
      payload: {
         key: isAddonJourney ? 'FAMILY_CHILD' : 'FAMILY_PARENT',
         clearOnLogout: true,
         value: {
            ...authTokensData,
            loggedInUser: authTokensData?.msisdn,
         },
      },
   };

   const dataLayerAction = {
      payload: {
         args: [
            {
               stepName: '2|Contact Details',
               event: 'lead_otp_submit',
            },
         ],
         utilName: 'handleGtmDataLayerEvent',
      },
      type: 'callUtilFunction',
   };

   actions.push(reduxActionObj);
   actions.push(dataLayerAction);

   // start of the API call
   const cancelOrderApiPayload = {
      payload: {
         authTokenGroup: 'FAMILY_PARENT',
         requestType: 'GET',
         header: {},
         queryParams: {},
         body: {},
         apiUrl: "guardian/api/buy/postpaid/prepaid-to-postpaid/cancelOrder/v9",
      },
      type: 'apiCall',
   }
   actions.push(cancelOrderApiPayload);
   // End of the API call

   setTimeout(() => {
      const nextApiObj: any = {
         payload: {
            authTokenGroup: 'FAMILY_PARENT',
            transactUserGroup: isAddonJourney ? 'FAMILY_CHILD' : null,
            header: {
               'x-request-id': '7f719fd4-2a6c-4bc3-9f1a-eb5cb892601e',
            },
            queryParams: {
               type: 'SI',
               journey,
               isCommon: true,
               simCardType: '{{additionalData:queryParams.simCardType}}',
               rtn: '{{storeValues:appData.msisdn}}',
               lineOfBusiness: 'MOBILITY',
            },
            requestType: 'GET',
            apiUrl: 'guardian/api/buy/postpaid/prepaid-to-postpaid/userDetails/addOn/v1',
         },
         type: 'apiCall',
      };


      const HVCheckApiObj: any = {
         payload: {
            requestType: 'POST',
            header: {
               'x-request-id': '7f719fd4-2a6c-4bc3-9f1a-eb5cb892601e',
            },
            queryParams: {
               journey: 'P2P',
               variant:storeValues?.variantContext?.variant
            },
            body: getPOQBodyForHV(msisdn, journey, isCoipUser, coipEmail),
            apiUrl:
               'guardian/api/buy/postpaid/prepaid-to-postpaid/eligibility/' + version,
         },
         type: 'apiCall',
      };

      if (isCoipUser) {
         nextApiObj.payload.authTokenGroup = 'FAMILY_PARENT'
         nextApiObj.payload.transactUserGroup = LOGIN_CONSTANTS.coipGroupId
         nextApiObj.payload.queryParams.isCoipUser = isCoipUser

         //for poq request
         HVCheckApiObj.payload.authTokenGroup = 'FAMILY_PARENT'
         HVCheckApiObj.payload.transactUserGroup = LOGIN_CONSTANTS.coipGroupId
         HVCheckApiObj.payload.body.isCoipUser = isCoipUser
      }

      const ucmApiUrl = `guardian/api/buy/postpaid/prepaid-to-postpaid/userProfile/${version}`;
      const userProfileObj = {
         payload: {
            authTokenGroup: 'FAMILY_PARENT',
            requestType: 'POST',
            header: {
               'x-request-id': '7f719fd4-2a6c-4bc3-9f1a-eb5cb892601e',
            },
            queryParams: {
               journey: 'P2P',
               isReferralJourney
            },
            body: {
               channel: {
                  id: 'TEST USER', // Todo: Randon Id
                  name: 'SHOP',
               },
               profileItem: [
                  {
                     siNumber: '{{storeValues:appData.msisdn}}',
                     type: 'SI',
                  },
               ],
               recoItem: [
                  {
                     rtn: '{{storeValues:appData.msisdn}}',
                     featureInclusion: ['CHECK_BLACK_CART'],
                  },
               ],
               ...(!skipPOQ && { poqItem: getPOQBodyForBundling() }),
            }, //TODO: handle body
            apiUrl: ucmApiUrl,
         },
         type: 'apiCall',
      };

      const addonActions = [];

      const storeIsReferralInRedux = {
         type: 'storeValuesInRedux',
         payload: {
            context: 'isReferralJourneyContext',
            data: {
               isReferralJourney,
               referralCode,
               refRtn
            },
         }
      }
      if(isReferralJourney){
         addonActions.push(storeIsReferralInRedux)
      }

      if (isAddonJourney) {
         addonActions.push(nextApiObj)
      } else if (['v7','v9', 'v20'].includes(version)) {
         addonActions.push(HVCheckApiObj)
      } else {
         addonActions.push(userProfileObj)
      }
      
      onUserAction({
         actions: addonActions,
      });
   }, 500);

   return onUserAction({
      actions,
   });
};

export const encodeData = (data: any) => {
   try {
      return btoa(encodeURIComponent(JSON.stringify(data)));
   } catch (error) {
      return '';
   }
};

export const decodeData = (data: any) => {
   try {
      return JSON.parse(decodeURIComponent(atob(data)));
   } catch (error) {
      return '';
   }
};

export const tokensHandlerOnReload = (
   onUserAction: any,
   localData: any,
   getState: any
) => {
   const actions: any = [];
   const { storeValues } = getState();
   const tokens = storeValues?.childOtp?.childTokens;

   if (Object.keys(tokens)?.length === 0) {
      const staticTkn = localStorage?.getItem(LOGIN_CONSTANTS.staticToken)?.toString();
      const dynamicTkn = localStorage?.getItem(LOGIN_CONSTANTS.dynamicToken)?.toString();
      const uidTkn = localStorage?.getItem(LOGIN_CONSTANTS.uid)?.toString();
      const loggedInTkn = localStorage?.getItem(LOGIN_CONSTANTS.loggedInUser)?.toString();

      if (staticTkn && dynamicTkn && uidTkn && loggedInTkn)
         actions.push({
            type: 'storeValuesInRedux',
            payload: {
               context: 'childTokens',
               data: {
                  [LOGIN_CONSTANTS.staticToken]: staticTkn,
                  [LOGIN_CONSTANTS.dynamicToken]: dynamicTkn,
                  [LOGIN_CONSTANTS.uid]: uidTkn,
                  [LOGIN_CONSTANTS.loggedInUser]: loggedInTkn,
               },
            },
         });
   }

   return onUserAction({ actions });
};

/**
 * generate a random uuid
 * @returns {string}
 */
export const createUUID = () => {
   let dt = new Date().getTime();
   const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = (dt + Math.random() * 16) % 16 | 0;
      dt = Math.floor(dt / 16);
      return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
   });

   return uuid;
};

export const encryptMessage = (payload: any, publickey: string) => {
   //generate random number
   const secretKey = createUUID();
   const stringifyPayload = JSON.stringify(payload);
   const currentTime = Date.now().toString();

   //DES encryption of payload
   const encryptedPayload = desEncryptMessage(stringifyPayload, secretKey);

   //DES encryption of timestamp
   const encryptedTimestamp = desEncryptMessage(currentTime, secretKey);

   //encrypt random key
   const encryptedKey = encryptSecretKey(secretKey, publickey);

   return `data=${encodeURIComponent(
      encryptedPayload
   )}&key=${encryptedKey}&timestamp=${encodeURIComponent(encryptedTimestamp)}`;
};


export const useParamAndFindBundling = (
   data: any,
   onUserAction: any,
   getState: any
) => {
   const { storeValues } = getState();
   const isCoipUser = !!storeValues?.userData?.isCoipUser;
   const domain = storeValues?.userData?.domain;
   let search = window.location.search;
   let params = new URLSearchParams(search);
   let price = params.get('price');
   let bundlingLob = params.get('lob')
   const isApp = isMobileApp();
   let apiVersion = (storeValues.versionContextNP2P?.version);

   let authTokenGroup = "FAMILY_PARENT_WEB_TOKEN_SHORTLIVED";
   let transactUserGroup = "";
   if (isCoipUser) {
      if (isApp) {
         transactUserGroup = LOGIN_CONSTANTS.coipGroupId
      } else {
         authTokenGroup = LOGIN_CONSTANTS.coipGroupId;
      }
   }

   const apiUrl = `guardian/api/buy/postpaid/non-postpaid/getProductCatalog/bundling/v${isCoipUser ? '20' : (apiVersion ? apiVersion : '1')}`;

   return onUserAction({
      actions: [
         {
            payload: {
               context: 'userData',
               data: {
                  lob: 'POSTPAID',
               },
            },
            type: 'storeValuesInRedux',
         },
         {
            payload: {
               onError: {
                  actions: [
                     {
                        payload: {
                           data: {
                              price: 449,
                              selectedPlan: 'PKG_50861',
                           },
                           context: 'planData',
                        },
                        type: 'storeValuesInRedux',
                     },
                     {
                        payload: {
                           eventData: {
                              heading: 'Infinity 449 Plan',
                              subHeading: '40 GB · 1 SIM',
                           },
                           shouldResolveData: true,
                           eventName: 'AddDetailsLinkListWidget',
                        },
                        type: 'nativeEventEmitter',
                     },
                     {
                        payload: {
                           data: {
                              lob: 'POSTPAID',
                           },
                           context: 'userData',
                        },
                        type: 'storeValuesInRedux',
                     },
                  ],
               },
               requestType: 'GET',
               authTokenGroup,
               transactUserGroup,
               apiUrl,
               queryParams: {
                  siNumber: '9739498989',
                  defaultPlanPrice: price,
                  lob: 'POSTPAID',
                  isCoipUser,
                  domain,
                  bundlingLob
               },
               body: {},
            },
            type: 'apiCall',
         },
      ],
   });
};
